'use client';

import { ReactNode, useMemo } from 'react';
import type { AgencySchema } from '@ametista-ai/api-schema';
import { LDProvider } from 'launchdarkly-react-client-sdk';

export function FlagsProvider({
  children,
  agency,
  ldKey,
}: {
  children: ReactNode;
  agency?: AgencySchema;
  ldKey: string;
}) {
  const context = useMemo(
    () =>
      agency
        ? {
            kind: 'multi',
            agency: {
              key: agency.id,
              name: agency.name,
            },
          }
        : undefined,
    [agency]
  );

  if (!ldKey) {
    console.warn('Flags not initialized');
    return children;
  }

  return (
    <LDProvider clientSideID={ldKey} context={context} deferInitialization>
      {children}
    </LDProvider>
  );
}
